/**
 * 模型自动发现系统(过渡版本)
 * - 当前阶段:手动导入,但统一格式
 * - 未来升级:构建时自动扫描
 */
import type { ModelDefinition } from '@/features/models/modelDefinition';
import { isValidModelDefinition, toModelConfigEntry } from '@/features/models/modelDefinition';
import { modelLoaders } from './modelAutoDiscovery.generated';
import type { ModelConfigEntry } from './models.config';

/**
 * 导入所有模型定义
 * TODO: 后续可改为构建时自动生成此文件
 */
async function importAllModelDefinitions(): Promise<unknown[]> {
  const definitions: unknown[] = [];

  for (const { key, loader } of modelLoaders) {
    try {
      const mod = await loader();
      if (mod?.MODEL_DEFINITION) {
        definitions.push(mod.MODEL_DEFINITION);
      }
    } catch {
      // 忽略加载失败的模型
    }
  }

  return definitions;
}

/**
 * 发现并转换模型配置
 * @returns 自动发现的 ModelConfigEntry 数组
 */
export async function discoverModels(): Promise<ModelConfigEntry[]> {
  const definitions = await importAllModelDefinitions();
  const configs: ModelConfigEntry[] = [];

  for (const def of definitions) {
    if (!isValidModelDefinition(def)) {
      continue;
    }

    configs.push(toModelConfigEntry(def));
  }

  return configs;
}
